// TasksPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const TasksPage = () => <ComingSoon title="Tasks" description="General task tracking. Housekeeping and Maintenance have their own task lists." />;

export default TasksPage;
